import { render } from "./BuildEnv.vue?vue&type=template&id=5af4bc83"
import script from "./BuildEnv.vue?vue&type=script&lang=js"
export * from "./BuildEnv.vue?vue&type=script&lang=js"

import "./BuildEnv.vue?vue&type=style&index=0&id=5af4bc83&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__